import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { IContactGroup, IContactItem } from '../../../store/models/contact.model';
import { ContactsService } from '../../../store/services/contacts.service';
import { SessionService } from '../../../store/services/session.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TABLE_COMPONENT, TableComponent } from '../../../shared/ui/table/table.component';
import { HttpErrorResponse } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { IReducers } from '../../../store/reducers';
import { openSnackbar } from '../../../store/actions/page.action';

@Component({
  selector: 'app-manager-group-selector',
  templateUrl: './manager-group-selector.component.html',
  styleUrls: ['./manager-group-selector.component.scss'],
})
export class ManagerGroupSelectorComponent implements OnInit, OnDestroy {
  data: IContactItem;
  groups: IContactGroup[];
  ready: boolean;
  useSelector: boolean;

  private readonly destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private readonly contactsService: ContactsService,
    private readonly sessionService: SessionService,
    @Inject(TABLE_COMPONENT) private readonly tableComponent: TableComponent,
    private readonly store$: Store<IReducers>,
  ) {
  }

  ngOnInit(): void {
    this.sessionService
      .onReady()
      .pipe(takeUntil(this.destroy$))
      .subscribe(session => {
        if (this.data && this.data.account_id) {
          if (this.data.account_id === session.id) {
            this.useSelector = true;
          }
          this.ready = true;
        }
      });
  }

  getGroups() {
    if (!this.groups) {
      return [];
    }

    return this.groups.map(g => ({
      label: g.group_name,
      value: g.group_id,
      selected: this.data.group_id === g.group_id,
    }));
  }

  onSelection(value) {
    this.contactsService
      .updateContact(this.data.contact_id, {
        group_id: parseInt(value, 10),
      })
      .subscribe(
        () => {
          if (this.tableComponent) {
            this.tableComponent.refresh();
          }
        },
        (error: HttpErrorResponse) =>
          this.store$.dispatch(
            openSnackbar({
              snackbarData: {
                data: {
                  type: 'error',
                  message: error.error,
                },
              },
            }),
          ),
      );
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
  }
}
